/**
 * UI component to highlight checkpoint nodes within a content module
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

const CheckpointMarker = ({
  match
  , node
  , onNodeClick
  , reachedConclusion
  , scene
  , viewedNodes
}) => {
  const hasViewed = _.includes(viewedNodes, node._id);
  if(hasViewed) {
    return (
      <Link
        className="-marker -viewed"
        onClick={() => onNodeClick(node._id)}
        to={`${match.url.replace(match.params.nodeId, node._id)}?prev=${match.params.nodeId}`}
      >
        <ReactTooltip
          aria-haspopup='true'
          className="yt-tooltip"
          id={`node-${node._id}`}
          place="top"
          type="dark"
        >
          <p>Viewed checkpoint: {scene.title}</p>
        </ReactTooltip>
        <div className="-icon" >
          <i className="far fa-play-circle fa-lg" />
        </div>
        <div className="-super" data-tip data-for={`node-${node._id}`} >
          <i className="fas fa-check-circle fa-lg"/>
        </div>
      </Link>
    )

  } else if(reachedConclusion) {
    return(
      <Link
        className="-marker"
        onClick={() => onNodeClick(node._id)}
        to={`${match.url.replace(match.params.nodeId, node._id)}?prev=${match.params.nodeId}`}
      >
        <ReactTooltip
          aria-haspopup='true'
          id={`node-${node._id}`}
          className="yt-tooltip"
          place="top"
          type="dark"
          >
          <p>Missed checkpoint: {scene.title}</p>
        </ReactTooltip>
        <div className="-icon" >
          <i className="far fa-play-circle fa-lg" />
        </div>
        <div className="-super" data-tip data-for={`node-${node._id}`} >
          <i className="far fa-play-circle fa-lg"/>
        </div>
      </Link>
    )
  } else {
    return (
      <div className="-marker">
        <ReactTooltip
          aria-haspopup='true'
          id={`node-${node._id}`}
          className="yt-tooltip"
          place="top"
          type="dark"
          >
          <p>Unviewed checkpoint</p>
        </ReactTooltip>
        <div className="-icon" data-tip data-for={`node-${node._id}`} >
          <i className="far fa-play-circle fa-lg"/>
        </div>
      </div>
    )
  }
}

CheckpointMarker.propTypes = {
  node: PropTypes.object.isRequired
  , onNodeClick: PropTypes.func.isRequired
  , reachedConclusion: PropTypes.bool
  , scene: PropTypes.object.isRequired
  , viewedNodes: PropTypes.array
}

CheckpointMarker.defaultProps = {
  reachedConclusion: false
  , viewedNodes: []
}

export default withRouter(CheckpointMarker);



// WEBPACK FOOTER //
// modules/node/components/CheckpointMarker.js.jsx